"use client";

import { c as _c } from "react/compiler-runtime";
import type { Params } from "next/dist/server/request/params";
import { useParams } from "next/navigation";
import Alert from "@/components/alert";
import cn from "@/utils/cn";
import { trackedPlayers, wipes } from "..";
export default function Settings(t0) {
  const $ = _c(20);
  let {
    params
  } = t0;
  params = useParams() ?? params;
  const wipeIndex = Number(params.wipeId) - 1;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Alert severity="info" className="mb-10 w-full px-2.5">Settings are currently read-only.</Alert>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <thead><tr className="border-b"><th className="h-10 text-left py-1.5 px-2 bg-neutral-900">Tracked Players</th></tr></thead>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = trackedPlayers[wipeIndex];
  let t4;
  if ($[2] !== t3 || $[3] !== wipeIndex) {
    let t5;
    if ($[5] !== wipeIndex) {
      t5 = (trackedPlayer, i) => <tr key={trackedPlayer.name} className={cn("hover:bg-neutral-900/50", i < trackedPlayers[wipeIndex].length - 1 && "border-b")}><td className={cn("py-1.5 px-2", trackedPlayer.color)}>{trackedPlayer.name}</td></tr>;
      $[5] = wipeIndex;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = t3.map(t5);
    $[2] = t3;
    $[3] = wipeIndex;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div><div className="rounded overflow-hidden border"><table className="">{t2}<tbody>{t4}</tbody></table></div></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <thead><tr className="border-b"><th className="h-10 text-left py-1.5 px-2 bg-neutral-900">Ignored Weapons</th></tr></thead>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = wipes[wipeIndex];
  let t8;
  if ($[10] !== t7.ignoredWeapons || $[11] !== wipeIndex) {
    let t9;
    if ($[13] !== wipeIndex) {
      t9 = (weaponName, i_0) => <tr key={weaponName} className={cn("hover:bg-neutral-900/50", i_0 < wipes[wipeIndex].ignoredWeapons.length - 1 && "border-b")}><td className="py-1.5 px-2 bg-rose-900">{weaponName}</td></tr>;
      $[13] = wipeIndex;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    t8 = t7.ignoredWeapons.map(t9);
    $[10] = t7.ignoredWeapons;
    $[11] = wipeIndex;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div><div className="rounded overflow-hidden border"><table className="">{t6}<tbody>{t8}</tbody></table></div></div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t9) {
    t10 = <>{t1}<div className="flex gap-5">{t5}{t9}</div></>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}